import React from 'react'

import StatusDot from '../StatusDot'
import { RowDeprecated } from '@caudena/core/ui-kit'

import BlockClient from './BlockClient'
import capitalizeFirstLetter from '@caudena/core/utils/capitalizeFirstLetter'

export type ClientStatusType = 'blocked' | 'active'

interface ClientStatusProps {
  status?: ClientStatusType
}

export const ClientStatus = ({ status }: ClientStatusProps) => {
  const statusText = capitalizeFirstLetter(status)

  return (
    <RowDeprecated gap={0.5}>
      <StatusDot status={status} />
      {statusText}
    </RowDeprecated>
  )
}

interface ClientActionsProps {
  id?: string
  status?: ClientStatusType | undefined | null
  showStatus?: boolean
  onStatusChange?: (status?: ClientStatusType) => void
}

const ClientActions = ({
  id,
  status,
  showStatus = false,
  onStatusChange,
}: ClientActionsProps) => {
  const [currentStatus, setCurrentStatus] = React.useState<
    ClientStatusType | undefined | null
  >(status)

  React.useEffect(() => {
    setCurrentStatus(status)
  }, [status])

  const handleBlock = async () => {
    setCurrentStatus('blocked')
    onStatusChange?.('blocked')
  }

  let actions: React.ReactNode | null = null

  if (currentStatus === 'active' && id != null) {
    actions = <BlockClient id={id} onSubmitSuccess={handleBlock} />
  }

  if (currentStatus === 'blocked') {
    // actions = <ActivateClient id={id} onSubmitSuccess={handleActivate} />
  }

  if (showStatus) {
    return (
      <RowDeprecated>
        <ClientStatus status={currentStatus ?? undefined} />
        {actions}
      </RowDeprecated>
    )
  }

  return actions
}

export default ClientActions
